import { useMemo, useState } from "react";
import { FieldValues, UseFormReturn } from "react-hook-form";
import styled from "styled-components";
import { z } from "zod";
import { Button } from "../../atoms/Button";
import { Input } from "../../atoms/Input";
import FormTemplate from "../../templates/FormTemplate";

type Props = {
  handleSubmit: (email: string, password: string) => void;
};

export const DeactivateForm: React.FC<Props> = ({ handleSubmit }) => {
  const schema = useMemo(() => {
    return z.object({
      email: z.string().min(1),
      password: z.string().min(1),
    });
  }, []);

  const [methods, setMethods] = useState<UseFormReturn<
    FieldValues,
    any,
    undefined
  > | null>(null);

  return (
    <FormTemplate
      schema={schema}
      setMethods={setMethods}
      defaultValues={{
        email: "",
        password: "",
      }}
      onSubmit={({ email, password }) => handleSubmit(email, password)}
    >
      <InputContainer>
        <Input
          name="email"
          type="email"
          label="ご登録のメールアドレス"
          required
          dataWovnIgnore={true}
        />
      </InputContainer>

      <InputContainer>
        <Input
          name="password"
          type="password"
          label="パスワード"
          required
          hidePasswordToggle
          isNewPassword
          dataWovnIgnore={true}
        />
      </InputContainer>

      <ButtonWrapper>
        <Button type="submit" text="退会する" btnStyle="primary" />
      </ButtonWrapper>
    </FormTemplate>
  );
};

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 36px 0 30px 0;
  button {
    font-family: "Hiragino Sans";
    line-height: 1;
    height: auto;
    font-weight: 500;
  }
`;

const InputContainer = styled.div`
  margin-bottom: 30px;
`;
